<script setup>

defineProps({
  match: {
    required: true,
    type: Object,
  },
})
</script>

<template>
  <div class="p-3">
    <div class="grid grid-cols-7 items-center gap-2">
      <!-- Heure -->
      <div class="col-span-1 text-center text-sm text-primary-600 font-medium">
        {{ match.time }}
      </div>

      <!-- Teams -->
      <div class="col-span-6">
        <div class="space-y-1">
          <!-- Team 1 -->
          <div
            class="flex overflow-hidden gap-2 items-center"
            v-for="(team, teamIndex) in [match.team1, match.team2]"
            :key="teamIndex"
           >
            <div class="w-5 h-5 min-w-5">
              <ImgComponent
                :src="team.logo"
                fallback="/images/match/t-shirt.svg"
                class="w-full h-full"
                alt=""
              />
            </div>
            <div class="truncate w-full font-medium text-primary-800">
              {{ team.name }}
            </div>
            <div class="w-6 min-w-6 text-right font-bold text-primary-900">
              {{ team.score ?? '-' }}
            </div>
          </div>
        </div>
      </div>
      <!-- Match terminé -->
      <div
        v-if="match.isFinished"
        class="col-span-7 text-center text-sm font-medium mt-2"
        :class="{
          'text-green-600':
            match.team1.score > match.team2.score ||
            match.team2.score > match.team1.score,
        }"
      >
        Match terminé
      </div>
    </div>
  </div>
</template>
